import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LoginModal from "@/components/LoginModal";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { Toaster } from "@/components/ui/sonner";

import EntryChoice from "@/pages/EntryChoice";
import PreLeasedHome from "@/pages/PreLeasedHome";
import AllProperties from "@/pages/AllProperties";
import PropertyDetail from "@/pages/PropertyDetail";
import CalculatorPage from "@/pages/CalculatorPage";
import ListYourProperty from "@/pages/ListYourProperty";
import RetailLeasingHome from "@/pages/RetailLeasingHome";
import RetailLeasingDetail from "@/pages/RetailLeasingDetail";
import BrokerPage from "@/pages/BrokerPage";
import AdminPage from "@/pages/AdminPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<EntryChoice />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route element={<MainLayout />}>
          <Route path="/retail-leasing" element={<RetailLeasingHome />} />
          <Route path="/retail-leasing/:id" element={<RetailLeasingDetail />} />
          <Route path="/broker" element={<BrokerPage />} />
          <Route path="/pre-leased" element={<PreLeasedHome />} />
          <Route path="/properties" element={<AllProperties />} />
          <Route path="/properties/:id" element={<PropertyDetail />} />
          <Route path="/calculator" element={<CalculatorPage />} />
          <Route path="/list-your-property" element={<ListYourProperty />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <LoginModal />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
